const Statement = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M7.25 16.75h9.5v-1.5h-9.5v1.5ZM5.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.282V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h13.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v13.385c0 .505-.175.932-.525 1.282-.35.35-.778.525-1.283.525H5.308Zm0-1.5h13.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.211V5.308a.294.294 0 0 0-.096-.211.294.294 0 0 0-.212-.097H5.308a.294.294 0 0 0-.212.097.294.294 0 0 0-.096.211v13.385c0 .077.032.147.096.211a.294.294 0 0 0 .212.096Z"
        />
        <path
            fill="currentColor"
            d="M11.607 13.448v-.777a1.824 1.824 0 0 1-.886-.468c-.236-.23-.403-.548-.502-.956l.9-.34c.08.302.203.52.366.655a.93.93 0 0 0 .611.2c.221 0 .396-.04.524-.122.128-.081.192-.21.192-.384a.537.537 0 0 0-.2-.42c-.135-.116-.429-.24-.883-.375-.477-.145-.815-.34-1.013-.585a1.345 1.345 0 0 1-.296-.873c0-.355.114-.652.345-.89.23-.239.51-.39.842-.454v-.76h.83v.76c.314.07.574.199.781.388.207.19.36.427.458.712l-.882.367a.877.877 0 0 0-.292-.41.81.81 0 0 0-.502-.15c-.215 0-.371.04-.467.119a.364.364 0 0 0-.144.292.43.43 0 0 0 .196.367c.131.093.424.206.878.34.425.128.75.326.978.594.227.268.34.588.34.96 0 .437-.128.772-.384 1.005a1.842 1.842 0 0 1-.96.445v.76h-.83Z"
        />
    </svg>
);

export default Statement;
